enum EnumDemandMotif {
  DEVIS = 'Demande de devis',
  REQUALIFIED = 'Demande requalifiée / traitée via un autre canal',
  DEMANDES_DINFORMATION_COMMERCIALE_OFFRE = "Demandes d'information commerciale/offre",
  RECLAMATION_COMMERCIALE = 'Réclamation commerciale',
  AUTRE = 'Autre',
}

export default EnumDemandMotif
